import { render, staticRenderFns } from "./popoverMenu.vue?vue&type=template&id=8e0c88d2"
import script from "./popoverMenu.vue?vue&type=script&lang=js"
export * from "./popoverMenu.vue?vue&type=script&lang=js"
import style0 from "./popoverMenu.vue?vue&type=style&index=0&id=8e0c88d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports